import { z } from 'zod';
import { documentSchema } from '../IDocument';

export const legalTransactionRelationshipDocumentSchema = documentSchema.extend(
  {
    DocumentPurpose: z.string(),
  }
);
